module.exports = __webpack_public_path__ + "static/media/add_icon_template.a46e3c31.svg";